import React from 'react';
import { Controller } from 'react-hook-form';
import styles from './form-control.module.css';
import classNames from 'classnames';
/**
 * @deprecated replaced by 'FormController'
 */
export function FormControl(props) {
    var _a = props.paddingBottom, paddingBottom = _a === void 0 ? 25 : _a, _b = props.showErrorMessages, showErrorMessages = _b === void 0 ? true : _b, _c = props.defaultErrorMessage, defaultErrorMessage = _c === void 0 ? 'There was an error' : _c, _d = props.defaultValue, defaultValue = _d === void 0 ? "" : _d;
    return (React.createElement(Controller, { control: props.control, rules: props.rules, name: props.name, defaultValue: defaultValue, render: function (controllerProps) {
            var _a;
            var hasError = !!controllerProps.fieldState.error;
            var error = (_a = controllerProps.fieldState.error) === null || _a === void 0 ? void 0 : _a.message;
            return (React.createElement("div", { className: styles.formControlWrapper, style: { paddingBottom: paddingBottom } },
                React.createElement("div", { className: styles.formControlOutlet }, props.render(controllerProps)),
                showErrorMessages && hasError && (React.createElement("div", { className: classNames("fieldErrorMessage", "formControlError"), style: { bottom: paddingBottom - 17 } }, error !== null && error !== void 0 ? error : defaultErrorMessage))));
        } }));
}
